import { useCallback } from "react";
import PortalDocuments from "../../../services/accounts/portalDocuments";
import saveAs from "file-saver";
import { useAppDispatch } from "../../../store";
import { setSuccessMessage } from "../../../acions/actionsCreators/messageActions";
import { SUCCESS_PDF_DOWNLOAD } from "../../../lib/constants";

export const useDownload = (
  setDownloadingItem: React.Dispatch<React.SetStateAction<string | undefined>>,
) => {
  const dispatch = useAppDispatch();

  const onDownload = useCallback(
    async (id: string, name: string, contractNumber: string) => {
      try {
        setDownloadingItem(id);

        const res: any = await PortalDocuments.download(contractNumber, id);

        if (res.type !== "application/pdf") {
          const blob = new Blob([res], { type: res.type });

          saveAs(blob, name);
        } else {
          dispatch(setSuccessMessage(SUCCESS_PDF_DOWNLOAD));

          const blob = new Blob([res], {
            type: "application/pdf",
          });
          const _url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = _url;
          link.target = "_blank";
          link.style.display = "none";
          link.click();
          link.remove();
        }

        setDownloadingItem(undefined);
      } catch {
        setDownloadingItem(undefined);
      }
    },
    [setDownloadingItem, dispatch],
  );

  return { onDownload };
};
